import React, { useState } from 'react';
import { Container, Form, Button, Spinner, Image, Modal } from 'react-bootstrap';
import NavbarComponent from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';

function Pokemon({ darkMode }) {
  const [pokemonId, setPokemonId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!pokemonId) return;
    const id = pokemonId;
    setLoading(true);
    try {
      const [pokemonRes, speciesRes] = await Promise.all([
        fetch(`https://pokeapi.co/api/v2/pokemon/${id}`),
        fetch(`https://pokeapi.co/api/v2/pokemon-species/${id}`),
      ]);
      if (!pokemonRes.ok) throw new Error('api');
      if (!speciesRes.ok) throw new Error('api');
      const [pokemonData, speciesData] = await Promise.all([
        pokemonRes.json(),
        speciesRes.json(),
      ]);
      const germanName = speciesData.names.find(n => n.language.name === 'de').name;
      const spriteUrl = pokemonData.sprites.front_default;
      setResult({ germanName, spriteUrl });
    } catch (err) {
      if (err instanceof TypeError) {
        setErrorMessage('Something went wrong. Please check your connection and try again.');
      } else {
        setErrorMessage(`No Pokémon found for ID ${id}. Please try another ID.`);
      }
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={darkMode ? 'dark-mode' : ''}>
      <NavbarComponent />
      <Container className="section-card">
        <h1>Pokémon</h1>
        <Form onSubmit={handleSearch}>
          <Form.Group className="mb-3" controlId="pokemonId">
            <Form.Label>Pokémon ID</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={pokemonId}
              onChange={(e) => setPokemonId(e.target.value)}
              placeholder="Enter Pokémon ID"
            />
          </Form.Group>
          <Button type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                {' '}Searching…
              </>
            ) : (
              'Search'
            )}
          </Button>
        </Form>
        {result && (
          <div className="mt-4">
            <h2>{result.germanName}</h2>
            {result.spriteUrl && (
              <Image
                src={result.spriteUrl}
                alt={result.germanName}
                style={{ width: 192, height: 192, imageRendering: 'pixelated' }}
              />
            )}
          </div>
        )}
      </Container>
      <Footer />
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Pokemon;
